import { axiosApi } from '@/axios'
import { createOrUpdateJSON } from '@/utils/functions'
import { Paginator, Params } from '@/utils/interfaces'
import {
  CreateTopUpIntegrationPriceDTO,
  GetTopUpIntegrationPriceDTO,
} from '@/utils/interfaces/topup.integration.interface'
import { AxiosResponse } from 'axios'

export const createTopUpIntegrationPrice = (
  body: CreateTopUpIntegrationPriceDTO | { is_active: boolean; uuid: string },
): Promise<AxiosResponse<GetTopUpIntegrationPriceDTO>> =>
  createOrUpdateJSON('/topups/integration/prices/', body)

export const getTopUpIntegrationPrices = (
  params?: Params,
): Promise<AxiosResponse<Paginator<GetTopUpIntegrationPriceDTO>>> =>
  axiosApi.get('/topups/integration/prices/', { params })
